export interface LookupDto {
  code: string;
  enumValue: number;
  groupName: string | null;
  localizationString: string;
  name: string;
  orderNumber: number;
}

export function enumToLookupDtos<T extends object>(enumObj: T, groupName: string | null = null): LookupDto[] {
  return Object.keys(enumObj)
    .filter((key) => isNaN(Number(key)))
    .map((key, idx) => {
      const name = key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
      return {
        code: key,
        enumValue: (enumObj as any)[key],
        groupName,
        localizationString: name.replace(/ /g, '_').toUpperCase(),
        name,
        orderNumber: idx + 1,
      };
    });
}
